import businessClient from 'src/services/clients/business'
import { IMeta, IEmbargo } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: [IEmbargo] }

export const integrationWolt = {
  /**
   * @param {{ api_key: string, menu_login: string, menu_sync: string }} data
   * @return {Promise<IResponse>}
   */
  pair(data, signal) {
    return businessClient().post('apppair/wolt/pair/business', { data }, { signal })
  },

  /**
   * @param {{ store_id: number, wolt_venue_id: string, wolt_venue_name: string }} data
   * @return {Promise<IResponse>}
   */
  pairStore(data, signal) {
    return businessClient().post('apppair/wolt/pair/store', { data }, { signal })
  },

  /**
   * @param {{ partner_id: number, entity_id: number }} filter
   * @return {Promise<IResponse>}
   */
  editPartnerData(filter, signal) {
    return businessClient().post('apppair/partner-data', { filter }, { signal })
  },

  /**
   * @param {{store_id:number}}filter
   * @return {Promise<IResponse>}
   */
  storeStatus(filter, signal) {
    return businessClient().post('apppair/wolt/store-status/list', { filter }, { signal })
  },

  /**
   * @param {{store_id: number, is_online: boolean }} data
   * @return {Promise<IResponse>}
   */
  changeStoreStatus(data, signal) {
    return businessClient().post('apppair/wolt/store-status/set', { data }, { signal })
  },

  /**
   * @param {{store_id: number, auto_accept_minute: number }} data
   * @return {Promise<IResponse>}
   */
  autoAccept(data, signal) {
    return businessClient().post('apppair/wolt/auto-accept', { data }, { signal })
  },

  /**
   * @param {{store_id: number }} filter
   * @return {Promise<IResponse>}
   */
  disconnect(filter, signal) {
    return businessClient().post('apppair/wolt/disconnect/store', { filter }, { signal })
  },
}
